var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L13 7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13C12.7761 13 13 12.7761 13 12.5C13 12.2239 12.7761 12 12.5 12C12.2239 12 12 12.2239 12 12.5C12 12.7761 12.2239 13 12.5 13Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.19997C3 4.6165 3.23179 4.05692 3.64437 3.64434C4.05695 3.23176 4.61653 2.99997 5.2 2.99997H6.2C6.7809 2.99964 7.33809 2.76957 7.75 2.35997L8.45 1.65997C8.65445 1.45437 8.89752 1.29121 9.16525 1.17988C9.43297 1.06855 9.72006 1.01123 10.01 1.01123C10.3 1.01123 10.587 1.06855 10.8548 1.17988C11.1225 1.29121 11.3656 1.45437 11.57 1.65997L12.27 2.35997C12.6819 2.76957 13.2391 2.99964 13.82 2.99997H14.82C15.4035 2.99997 15.9631 3.23176 16.3756 3.64434C16.7882 4.05692 17.02 4.6165 17.02 5.19997V6.19997C17.0203 6.78087 17.2504 7.33806 17.66 7.74997L18.36 8.44997C18.5656 8.65442 18.7288 8.89749 18.8401 9.16521C18.9514 9.43294 19.0087 9.72003 19.0087 10.01C19.0087 10.2999 18.9514 10.587 18.8401 10.8547C18.7288 11.1225 18.5656 11.3655 18.36 11.57L17.66 12.27C17.2504 12.6819 17.0203 13.2391 17.02 13.82V14.82C17.02 15.4034 16.7882 15.963 16.3756 16.3756C15.9631 16.7882 15.4035 17.02 14.82 17.02H13.82C13.2391 17.0203 12.6819 17.2504 12.27 17.66L11.57 18.36C11.3656 18.5656 11.1225 18.7287 10.8548 18.8401C10.587 18.9514 10.3 19.0087 10.01 19.0087C9.72006 19.0087 9.43297 18.9514 9.16525 18.8401C8.89752 18.7287 8.65445 18.5656 8.45 18.36L7.75 17.66C7.33809 17.2504 6.7809 17.0203 6.2 17.02H5.2C4.61653 17.02 4.05695 16.7882 3.64437 16.3756C3.23179 15.963 3 15.4034 3 14.82V13.82C2.99967 13.2391 2.76961 12.6819 2.36 12.27L1.66 11.57C1.4544 11.3655 1.29125 11.1225 1.17991 10.8547C1.06858 10.587 1.01126 10.2999 1.01126 10.01C1.01126 9.72003 1.06858 9.43294 1.17991 9.16521C1.29125 8.89749 1.4544 8.65442 1.66 8.44997L2.36 7.74997C2.76961 7.33806 2.99967 6.78087 3 6.19997V5.19997",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/PromotionIcon.44b54bda.svg";
export { ForwardRef as ReactComponent };